import React from 'react';
import { DOCUMENT_COLORS } from './UkDocumentUpload';

const PAYMENTS_EMAIL = 'payments@ezycollect.com';

const paragraph = { fontSize: '13px', lineHeight: 1.55, color: '#3c3f55', margin: '0 0 10px' };

const UkOutstandingDocumentsModal = ({ titles, onGoBack, onSubmitAnyway }) => {
  const plural = titles.length > 1;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(18,25,72,.45)',
        zIndex: 50,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        role="dialog"
        aria-label="Required documents outstanding"
        style={{
          background: '#fff',
          textAlign: 'left',
          borderRadius: '10px',
          maxWidth: '520px',
          width: '92%',
          padding: '26px 28px',
          boxShadow: '0 18px 50px rgba(18,25,72,.3)',
        }}
      >
        <h3 style={{ margin: '0 0 10px', color: '#1F2B7A', fontSize: '17px', fontWeight: 600 }}>
          Required documents outstanding
        </h3>
        <p style={paragraph}>
          The application can be submitted now, but{' '}
          <b>{`${titles.length} required document${plural ? 's remain' : ' remains'} outstanding`}</b>:
        </p>
        <p style={paragraph}>
          {titles.map((title) => (
            <React.Fragment key={title}>
              {`• ${title}`}
              <br />
            </React.Fragment>
          ))}
        </p>
        <p style={paragraph}>
          You will still be required to provide {plural ? 'these documents' : 'this document'} by emailing{' '}
          {plural ? 'them' : 'it'} to <b>{PAYMENTS_EMAIL}</b>, quoting your business name and CRN.
          Onboarding cannot be completed, and payment facilities cannot be activated, until all required documents are
          received and verified.
        </p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '18px' }}>
          <button
            type="button"
            onClick={onGoBack}
            style={{
              background: '#fff',
              border: `1px solid ${DOCUMENT_COLORS.border}`,
              color: DOCUMENT_COLORS.text,
              borderRadius: '6px',
              padding: '9px 18px',
              fontSize: '13px',
              cursor: 'pointer',
            }}
          >
            Go back & upload
          </button>
          <button
            type="button"
            onClick={onSubmitAnyway}
            style={{
              background: DOCUMENT_COLORS.orange,
              border: `1px solid ${DOCUMENT_COLORS.orange}`,
              color: '#fff',
              borderRadius: '6px',
              padding: '9px 18px',
              fontSize: '13px',
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Submit anyway
          </button>
        </div>
      </div>
    </div>
  );
};

export default UkOutstandingDocumentsModal;
